import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  title: () => faker.lorem.words(),

  description: () => faker.lorem.paragraph(),

  templateFontFace: "'Cera-Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  templateTextAlignment: 'left',

  withSubjectSection: trait({}),

  asInviteEmail: trait({
    title: 'Invite',
    identifier: 'registration',
    envoyDefault: true,
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', 'asInviteSubject', { mailerTemplate });
      server.create('mailer-section', 'asInviteHeader', { mailerTemplate });
      server.create('mailer-section', 'asInviteBody', { mailerTemplate });
    },
  }),

  asV2InviteEmail: trait({
    title: 'Invite',
    identifier: 'registration',
    envoyDefault: true,
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', 'asV2InviteSubject', { mailerTemplate });
      server.create('mailer-section', 'asV2InviteHeader', { mailerTemplate });
      server.create('mailer-section', 'asV2InviteBody', { mailerTemplate });
    },
  }),

  asWelcomeEmail: trait({
    title: 'Welcome',
    identifier: 'welcome',
    envoyDefault: true,
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', 'asWelcomeConditions', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeSubject', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeHeader', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeBody', { mailerTemplate });
    },
  }),

  asV2WelcomeEmail: trait({
    title: 'Welcome',
    identifier: 'welcome',
    envoyDefault: true,
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', 'asWelcomeConditions', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeSubject', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeHeader', { mailerTemplate });
      server.create('mailer-section', 'asWelcomeBody', { mailerTemplate });
    },
  }),

  withSectionsAndBlocks: trait({
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', { title: 'Subject', mailerTemplate });
      server.create('mailer-section', { title: 'Header', mailerTemplate });
      server.create('mailer-section', 'withBlocks', { title: 'Body', sortable: true, mailerTemplate });
    },
  }),

  withV2SectionsAndBlocks: trait({
    afterCreate(mailerTemplate, server) {
      server.create('mailer-section', { title: 'Subject', mailerTemplate });
      server.create('mailer-section', { title: 'Header', mailerTemplate });
      server.create('mailer-section', 'withV2Blocks', { title: 'Body', sortable: true, mailerTemplate });
    },
  }),

  withCompanyVersion: trait({
    afterCreate(mailerTemplate, server) {
      const company = server.schema.companies.find(1);

      server.create('mailer-template', {
        companyIds: [company.id],
        envoyDefault: false,
        envoyDefaultId: mailerTemplate.id,
      });
    },
  }),

  withLocationVersion: trait({
    afterCreate(mailerTemplate, server) {
      const location = server.schema.locations.find(1);
      server.create('mailer-template', {
        locationIds: [location.id],
        envoyDefault: false,
        envoyDefaultId: mailerTemplate.id,
      });
    },
  }),

  withVersions: trait({
    afterCreate(mailerTemplate, server) {
      const company = server.schema.companies.first();
      const location = server.schema.locations.first();
      server.create('mailer-template', {
        companyIds: [company.id],
        envoyDefault: false,
        envoyDefaultId: mailerTemplate.id,
      });

      server.createList('mailer-template', 2, {
        envoyDefaultId: mailerTemplate.id,
        locationIds: [location.id],
        envoyDefault: false,
      });
    },
  }),

  afterCreate(mailerTemplate, server) {
    if (mailerTemplate.envoyDefaultId) {
      // this is a child template, copy over sections and blocks from parent
      const parentTemplate = server.schema.mailerTemplates.find(mailerTemplate.envoyDefaultId);

      parentTemplate.mailerSections.models.forEach((section) => {
        server.create('mailer-section', {
          title: section.title,
          mailerTemplate,
          mailerBlocks: section.mailerBlocks.models.map((block) =>
            server.create('mailer-block', {
              requiredAttributes: block.requiredAttributes,
              title: block.title,
              identifier: block.identifier,
              deactivatable: block.deactivatable,
              sortable: block.sortable,
              editable: block.editable,
              settings: block.settings,
              position: block.position,
              active: block.active,
            }),
          ),
        });
      });
    }
  },
});
